import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faCalendarDay,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faExclamationTriangle,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faCalendarDay,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faExclamationTriangle,
  faQuestionCircle,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();

const ICONS: any = {
  calendar: 'fas fa-calendar-day',
  collapse: 'fas fa-chevron-up',
  error: 'fas fa-exclamation-triangle',
  expand: 'fas fa-chevron-down',
  next: 'fas fa-chevron-right',
  prev: 'fas fa-chevron-left',
  tooltip: 'fas fa-question-circle',
};

Vue.use(Vuetify);

export default new Vuetify({
  primary: '#056979',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  icons: {
    values: ICONS,
  },
  customProperties: true,
  theme: {
    themes: {
      light: {
        primary: '#056979',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
});
